import React__default, { useEffect } from 'react';
import Swiper from './../../../../external_lib/swiper/core/core.js';
import './../../../../external_lib/swiper/shared/dom.js';
import Navigation from './../../../../external_lib/swiper/modules/navigation/navigation.js';
import Pagination from './../../../../external_lib/swiper/modules/pagination/pagination.js';
import Autoplay from './../../../../external_lib/swiper/modules/autoplay/autoplay.js';
import { Swiper as Swiper$1 } from './../../../../external_lib/swiper/react/swiper.js';
import { SwiperSlide } from './../../../../external_lib/swiper/react/swiper-slide.js';
import CarouselProgressIndicator from '../../../../Molecules/CarouselProgressIndicator.js';
import Typography from '../../../../Atoms/Typography.js';
import { useTranslation } from 'react-i18next';
import LazyImage from '../../../../Atoms/LazyImage.js';

function MultipleImageMobile(_a) {
    var imageList = _a.imageList, topExtras = _a.topExtras, imageComponent = _a.imageComponent;
    Swiper.use([Navigation, Pagination, Autoplay]);
    var _b = React__default.useState(0), activeIndex = _b[0], setActiveIndex = _b[1];
    var _c = React__default.useState(0), imageNo = _c[0], setImageNo = _c[1];
    var _d = React__default.useState([]), slideValue = _d[0], setSlideValue = _d[1];
    useEffect(function () {
        if (imageList.length == 2)
            setSlideValue(['one', 'two']);
        else
            setSlideValue(['one', 'two', 'three']);
    }, [imageList === null || imageList === void 0 ? void 0 : imageList.length]);
    var activeIndexSelection = function (s) {
        setImageNo(s === null || s === void 0 ? void 0 : s.activeIndex);
        if ((s === null || s === void 0 ? void 0 : s.activeIndex) == 0)
            setActiveIndex(0);
        else if ((s === null || s === void 0 ? void 0 : s.activeIndex) == imageList.length - 1 && imageList.length > 2)
            setActiveIndex(2);
        else
            setActiveIndex(1);
    };
    var t = useTranslation().t;
    return (React__default.createElement("div", { className: "swiper-container" },
        React__default.createElement("div", { className: "icons" },
            React__default.isValidElement(topExtras) && (React__default.createElement("div", { className: "topExtras" }, React__default.cloneElement(topExtras))),
            imageList.length > 1 && (React__default.createElement("div", { className: "image-count" },
                React__default.createElement(Typography, { classes: "image-count-text", variant: "bodyTextTwo" }, t("".concat(imageNo + 1, "/").concat(imageList.length)))))),
        React__default.createElement("div", { className: "swiper-wrapper" },
            React__default.createElement(Swiper$1, { className: "swiper-component", navigation: false, pagination: false, slidesPerView: 1, spaceBetween: 0, onActiveIndexChange: function (s) { return activeIndexSelection(s); } }, imageList.map(function (image, index) { return (React__default.createElement(SwiperSlide, { className: "swiper-slider-component", key: index },
                React__default.createElement(LazyImage, { src: image, alt: "Slide ".concat(index + 1), classes: "my-image", imageComponent: imageComponent }))); }))),
        imageList.length > 1 && (React__default.createElement("div", { className: "progress-indicator" },
            React__default.createElement(CarouselProgressIndicator, { slides: slideValue, position: activeIndex })))));
}

export { MultipleImageMobile as default };
//# sourceMappingURL=multiple-image-mobile.js.map
